import { useContext, useEffect, useState } from "react";
import FormActa from "../../../views/Forms/FormActa";
import { useFormActaStore } from "../../../store/formActaStore";
import { UserContext } from "../../../context";
import { getEdad } from "../../../utils/getEdad";
import { Container } from "../../../components";

const CrearSolicitud = () => {
  const { setDefaultValues, defaultValues, tipos, barrios, setTipos, setBarrios, setLoading } =
    useFormActaStore();
  const { actions: ua } = useContext(UserContext);
  const perfil = ua.getPerfil();
  const [paso, setPaso] = useState();

  useEffect(() => {
    setDefaultValues({
      nombre_ciudadano: perfil.nombre,
      dni: perfil.documento,
      edad: getEdad(perfil?.fechaNacimiento),
      genero: perfil.genero,
      domicilio: perfil.direccion.split("-")[0],
      telefono: perfil.celular,
      email: perfil.correoElectronico,
      barrio_id: "",
      ultimo_paso: 0,
    });
  }, []);

  useEffect(() => {
    if (defaultValues) {
      setPaso(defaultValues?.ultimo_paso);
    }
  }, [defaultValues]);

  return (
    <Container
      linkBack={"/"}
      tituloApp={"ARBOLADO"}
      titulo={
        paso == 0
          ? "Paso 1 - Datos del ciudadano"
          : paso == 1
          ? "Paso 2 - Datos de la solicitud"
          : paso == 2
          ? // ? "Paso 3 - Adjuntar imagenes"
            "Paso 3 - Solicitud enviada"
          : paso == 3
          ? "Paso 4 - Revisión de datos"
          : ""
      }
      size={"sm"}
    >
      <FormActa />
    </Container>
  );
};

export default CrearSolicitud;
